<!--Header-->
<div class="TextCenter">
	<h4>Facility Name and Address:</h4>
</div>

<div class="TextCenter ExtraMargin">
	<label>Name:</label>
</div>

<!--Name-->
<div class="fd-Menu TopMargin">
	<label>Facility Name:</label>
	<input [disabled]="DataLoading == true" [(ngModel)]="FacilityName" placeholder="Enter Facility Name" class="form-control" type="text" />

	<label>Facility Code:</label>
	<input [disabled]="DataLoading == true" [(ngModel)]="FacilityCode" placeholder="Enter Facility Number or Abbreviation" class="form-control" type="text" />

	<label>Defined By:</label>
	<label>{{ GetUserLevelDesc() }}</label>
</div>

<div class="TextCenter ExtraMargin">
	<label>Address:</label>
</div>

<!--Address-->
<div class="fd-Menu TopMargin">
	<label>Phone:</label>
	<input [disabled]="DataLoading == true" maxlength="14" [(ngModel)]="Phone" placeholder="Enter Phone Number ###-###-####" class="form-control" type="text" />

	<label>Address:</label>
	<input [disabled]="DataLoading == true" [(ngModel)]="Address" placeholder="Enter Street Address" class="form-control" type="text" />

	<label>City:</label>
	<input [disabled]="DataLoading == true" [(ngModel)]="City" placeholder="Enter Town or City" class="form-control" type="text" />

	<label>State:</label>
	<input [disabled]="DataLoading == true" [(ngModel)]="State" maxlength="2" placeholder="Enter State Abbreviation" class="form-control" type="text" />

	<label>Zip:</label>
	<input [disabled]="DataLoading == true" [(ngModel)]="Zip" maxlength="10" placeholder="Enter Zip Code" class="form-control" type="text" />
</div>

<div *ngIf="EditMode == true" class="TextCenter TopMargin">
	<label class="WarnText">NOTE: you have to go to the last page to save your changes and update the facility</label>
</div>

<!--Next-->
<div class="TextCenter TopMargin">
	<button [disabled]="DataLoading == true" class="btn btn-primary" (click)="onNext()">Next</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
